<div class="card-container">
  <div class="top-content">
    <div class="title-row">
      {{taxonomy.taxonomy_name}}
      <!-- PHASE 1: NOT NEEDED -->
      <!-- <img class="more-icon" src="assets/icons/more_taxonomy.svg" alt="more-icon" (click)="handleMorePress()">
      @if (_showMoreDropdown()) {
      <div class="more-drop-down">
        <div class="more-item" (click)="handleRenameTaxonomy($event, taxonomy.taxonomy_id, taxonomy.taxonomy_name)">
          <img class="more-item-icon" src="assets/icons/taxonomy_rename.svg" alt="more-item-icon">
          Rename Taxonomy
        </div>
        <div class="more-item">
          <img class="more-item-icon" src="assets/icons/taxonomy_groups.svg" alt="more-item-icon">
          Share Taxonomy
        </div>
        <div class="delete-container">
          <button class="btn-delete-taxonomy" (click)="handleDeleteTaxonomy($event, taxonomy.taxonomy_id)">
            <img src="assets/icons/taxonomy_delete.svg" alt="add-icon">
            Delete Taxonomy
          </button>
        </div>

      </div>
      } -->
    </div>
    <div class="publish-label" [ngClass]="{'published': taxonomy.version_status == 'published'}">{{taxonomy.version_status == 'published' ? 'Published':
      'draft'}}</div>
    <div class="sub-section">
      <div class="section-item">
        <div class="title">
          <img class="title-icon" src="assets/icons/taxonomy_groups.svg" alt="group-icon">
          Queue Group:
        </div>
        <!-- <div class="value">{{taxonomy.linked_queue_groups}}</div> -->
        <div class="value">
          <ng-container *ngIf="(taxonomy.linked_queue_groups?.length ?? 0) > 0; else noData">
            {{ taxonomy.linked_queue_groups }}
          </ng-container>
          <ng-template #noData>NA</ng-template>
        </div>
      </div>
      <div class="section-item">
        <div class="title">
          <img class="title-icon" src="assets/icons/taxonomy_date_range.svg" alt="date-icon">
          Created On:
        </div>
        <div class="value">{{taxonomy.created_on | customDateTime:'date'}}</div>
      </div>
    </div>
  </div>
  <div class="bottom-content" (click)="handleViewTaxonomy($event, taxonomy.taxonomy_id, taxonomy.taxonomy_name)">
    View Details
    <img class="more-icon" src="assets/icons/taxonomy_arrow_right.svg" alt="right-icon">
  </div>
</div>
